module.exports = __webpack_public_path__ + "static/media/sound_4.b02360b7.mp3";